import React, { useState, useEffect, useRef } from 'react';
import { Switch, Route, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import {
  userActions,
  // subscriptionActions,
} from '../../../../actions';
import { useTranslation } from 'react-i18next';
import AuthImage from "../../../common/AuthImage";

const UserAction = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector(state => state.authentication.user);
  const location = useLocation();
  const { path, url } = useRouteMatch();
  const [visible, setVisible] = useState(false);
  const clientName = `${_.get(user, 'details.firstname', '')} ${_.get(
    user,
    'details.lastname',
    '',
  )}`.trim();

  const logout = () => {
    // dispatch(subscriptionActions.resetState());
    dispatch(userActions.logout());
    history.push('/');
  };

  const toggleUserActions = () => {
    setVisible(!visible)
  }

  return (
    <NavItem tag={Dropdown} caret toggle={toggleUserActions}>
      <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
        <AuthImage
          className="user-avatar rounded-circle mr-2"
          src={(`${process.env.REACT_APP_FILE_SERVER}/users/${_.get(user, 'userId')}/avatar.png`)}
          alt="User Avatar"
        />
        {" "}
        <span className="d-none d-md-inline-block">{_.isEmpty(clientName) ? t('noName') : clientName}</span>
      </DropdownToggle>
      <Collapse tag={DropdownMenu} right small open={visible}>
        <DropdownItem as={Link} to="user-profile">
          <i className="material-icons">&#xE7FD;</i> Profile
          </DropdownItem>
        <DropdownItem as={Link} to="edit-user-profile">
          <i className="material-icons">&#xE8B8;</i> Edit Profile
          </DropdownItem>
        {/* <DropdownItem as={Link} to="file-manager-list">
            <i className="material-icons">&#xE2C7;</i> Files
          </DropdownItem> */}
        {/* <DropdownItem as={Link} to="transaction-history">
            <i className="material-icons">&#xE896;</i> Transactions
          </DropdownItem> */}
        <DropdownItem divider />
        <DropdownItem as={Link} onClick={logout} className="text-danger">
          <i className="material-icons text-danger">&#xE879;</i> Logout
          </DropdownItem>
      </Collapse>
    </NavItem>
  );

}

export default UserAction;